import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import CartNew from '@checkout/components/pages/Cart';
import {
    CheckoutOrderButtonProvider
} from '@checkout/components/last-check/storybook/context/CheckoutOrderButtonContext.js';
import {SideSectionProvider} from '@product/sections/SideSectionContext.tsx';

const {moduleScope, config} = JshModule('checkout/cart');

const {
    model,
    totalSavingsEnabled = false,
} = config;

    createRoot(moduleScope).render(
        <CheckoutOrderButtonProvider>
            <SideSectionProvider>
                <CartNew
                    texts={model.texts}
                    cartSummary={model.cartSummary}
                    sortedAndGroupedCartItems={model.sortedAndGroupedCartItems}
                    acceptedPaymentTypes={model.acceptedPaymentTypes}
                    benefits={model.benefits}
                    couponData={model.couponData}
                    hideLoginHint={model.hideLoginHint}
                    recommendationParams={model.recommendationParams}
                    giveawayItem={model.cart.giveawayItem}
                    totalSavingsEnabled={totalSavingsEnabled}
                shippingCostPromotion={model.shippingCostPromotion}/>
            </SideSectionProvider>
        </CheckoutOrderButtonProvider>,
    );

